module.exports = __webpack_public_path__ + "img/secure_code_logo.83c1b0ae.png";